<template>
  <page-wrapper :title="pageWrapper.title" :hasPad="pageWrapper.hasPad">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="mt-3">รายการ Articles</h1>
          <articles-selector
              class="input"
              v-model="pinnedArticles"
              :disabled="disabled"
            ></articles-selector>
        </div>
      </div>
      <div class="row">
        <div class="col text-right padding-adjust">
          <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ArticlesSelector from "@/lib/components/ArticlesSelector/ArticlesSelector";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { transformArticlesResponseToListItem } from "../transform";

export default {
  components: {
    PageWrapper,
    ScButton,
    'articles-selector': ArticlesSelector
  },
  created() {
    this.setup();
  },
  data() {
    const pageWrapper = {
      title: "Pinned Article",
      hasPad: false
    };
    const pinnedArticles = [];
    const disabled = false;
    return {
      pageWrapper,
      pinnedArticles,
      disabled
    }
  },
  methods: {
    async setup() {
      const pinnedResponse = await baanRueJaiClient.admin.articles.getPin('PINNED_ARTICLE');
      this.pinnedArticles = pinnedResponse.data.result.map((item) =>
        transformArticlesResponseToListItem(item)
      );
    },
    async handleClickSave() {
      try {
        const requestPinnedArticles = this.pinnedArticles.map(
          pinnedArticle => pinnedArticle.id
        );
        const params = {
          article_ids: requestPinnedArticles
        };
        await baanRueJaiClient.admin.articles.putPin("PINNED_ARTICLE", params);

        alert("บันทึกสำเร็จ");
      } catch (error) {
        alert("ไม่สามารถบันทึก ได้ กรุณาลองใหม่อีกครั้ง");
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-adjust {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/features/articles/pages/ArticlePinPage.vue